import { pbrExt } from './fragments/unlit-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrUnlit(mat, unlitColor) {
  mat._unlit = true;
  if (unlitColor) {
    mat._unlitColor = unlitColor;
  }
  _registerPbrExt(pbrExt);
}

export { setPbrUnlit };
//# sourceMappingURL=set-unlit.js.map
